export function getAllAccountNames(accountTitle?: string, accountNames?: string[]): string {
  const result: string[] = []

  if (accountTitle) {
    result.push(accountTitle)
  }

  if (accountNames && accountNames.length > 0) {
    accountNames.forEach((name) => {
      result.push(name)
    })
  }

  return result.join(' ')
}
